module.exports = __webpack_public_path__ + "static/img/P4.9f57800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P4.png
// module id = 0TWs
// module chunks = 0